import * as Yup from 'yup';

import { useLazyGetFilterOptionsQuery } from '../../../../../../services/contacts';

export const useJobTitleFilter = ({ sharedList, orderBy, setFilters }) => {
  const [getFilterOptions, { data, isLoading, isFetching }] = useLazyGetFilterOptionsQuery();

  const jobTitleIncludedOptions = [
    { label: 'Current', value: 'current' },
    { label: 'Recent', value: 'recent' },
    { label: 'Current and past', value: 'all' },
  ];

  const formSchema = Yup.object().shape({
    jobTitles: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
    jobTitlesIncluded: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string(),
    }),
  });

  const onSearchChange = (currentValue) =>
    getFilterOptions({
      facet: 'job_titles',
      query: currentValue,
      sharedList,
      orderBy,
    })
      .unwrap()
      .catch(() => []);

  const onSubmit = ({ jobTitles, jobTitlesIncluded }) => {
    const filters = { jobTitles };

    // Only include jobTitlesIncluded if there are job titles selected
    if (jobTitles && jobTitles.length > 0) {
      filters.jobTitlesIncluded = jobTitlesIncluded;
    }

    setFilters(filters);
  };

  return {
    formSchema,
    onSearchChange,
    onSubmit,
    jobTitleIncludedOptions,
    data,
    isLoading,
    isFetching,
  };
};
